import { gql } from '@apollo/client';

export interface GetLessonFoldersCountResponse {
    lessonFoldersCount: number;
}

export const GET_LESSON_FOLDERS_COUNT = gql`
    query LessonFoldersCount($where: LessonFolderWhereInput) {
        lessonFoldersCount(where: $where)
    }
`;

export interface GetLessonFoldersResponse {
    lessonFolders: {
        id: string;
        name: string;
        dateCreated: string;
        dateUpdated: string;
        teacher: {
            id: string;
        };
        shares: {
            id: string;
        }[];
    }[];
}

export const GET_LESSON_FOLDERS = gql`
    query LessonFolders($where: LessonFolderWhereInput!, $orderBy: [LessonFolderOrderByInput!]!, $take: Int, $skip: Int!) {
        lessonFolders(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
            id
            name
            dateCreated
            dateUpdated
            teacher {
                id
            }
            shares {
                id
            }
        }
    }
`;

export interface CreateLessonFolderVariables {
    data: {
        name: string;
    };
}

export interface CreateLessonFolderResponse {
    createLessonFolder: {
        id: string;
        name: string;
        dateCreated: string;
        dateUpdated: string;
        teacher: {
            id: string;
        };
        shares: {
            id: string;
        }[];
    };
}

export const CREATE_LESSON_FOLDER = gql`
    mutation CreateLessonFolder($data: LessonFolderCreateInput!) {
        createLessonFolder(data: $data) {
            id
            name
            dateCreated
            dateUpdated
            teacher {
                id
            }
            shares {
                id
            }
        }
    }
`;

export interface UpdateLessonFolderVariables {
    data: {
        name?: string;
    };
    where: {
        id: string;
    };
}

export interface UpdateLessonFolderResponse {
    updateLessonFolder: {
        id: string;
        name: string;
        dateCreated: string;
        dateUpdated: string;
        teacher: {
            id: string;
        };
        shares: {
            id: string;
        }[];
    };
}

export const UPDATE_LESSON_FOLDER = gql`
    mutation UpdateLessonFolder($where: LessonFolderWhereUniqueInput!, $data: LessonFolderUpdateInput!) {
        updateLessonFolder(where: $where, data: $data) {
            id
            name
            dateCreated
            dateUpdated
            teacher {
                id
            }
            shares {
                id
            }
        }
    }
`;

export interface DeleteLessonFoldersVariables {
    where: {
        id: string;
    }[];
}

export interface DeleteLessonFoldersResponse {
    deleteLessonFolders: {
        id: string;
        name: string;
        dateCreated: string;
        dateUpdated: string;
        teacher: {
            id: string;
        };
        shares: {
            id: string;
        }[];
    }[];
}

export const DELETE_LESSON_FOLDERS = gql`
    mutation DeleteLessonFolders($where: [LessonFolderWhereUniqueInput!]!) {
        deleteLessonFolders(where: $where) {
            id
            name
            dateCreated
            dateUpdated
            teacher {
                id
            }
            shares {
                id
            }
        }
    }
`;
